<template>
  <div class="modal">
    <div class="modal-body">
  <!-- <Modal :title="title" :value="true" :loading="true" :mask-closable="false" width="80"> -->
      <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="100">
        <!-- <Divider orientation="left">商品规格</Divider> -->
  <!--       <sl-label v-show="item.visible" v-for="(item,index) in specs" :title="item.name" :key="'specs'+index" :label-width="100">
          <sl-select v-model="item.value" :full-props="true" :placeholder="'请选择'+item.name" type="radio" :data="item.children" @on-change="handleChangeSpec"></sl-select>
        </sl-label> -->
        <!-- <Divider orientation="left">基本信息</Divider> -->
        <FormItem label="规格">

          <sl-detail-list :col="1" label-align="right">
            <sl-detail-list-item v-show="item.visible" v-for="(item,index) in specs" :title="item.name" :key="'specs'+index" :label-width="65">
              <sl-select v-model="item.value" :full-props="true" :placeholder="'请选择'+item.name" type="radio" :data="item.children" @on-change="handleChangeSpec"></sl-select>
            </sl-detail-list-item>
          </sl-detail-list>
        
        </FormItem>
        <Row>
          <Col span="12">
            <FormItem label="名称" prop="name">
              <Input v-model="form.name"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="尺寸">
              <Row type="flex" justify="space-between">
                <Col span="7"><InputNumber :min="0.001" :active-change="false" v-model="form.length" :formatter="v => `${v} mm`" :parser="v => v.replace(' mm', '')" placeholder="长度"></InputNumber></Col>
                <Col span="7"><InputNumber :min="0.001" :active-change="false" v-model="form.width" :formatter="v => `${v} mm`" :parser="v => v.replace(' mm', '')" placeholder="宽度"></InputNumber></Col>
                <Col span="7"><InputNumber :min="0.001" :active-change="false" v-model="form.height" :formatter="v => `${v} mm`" :parser="v => v.replace(' mm', '')" placeholder="高度"></InputNumber></Col>
              </Row>
            </FormItem>
          </Col>
        </Row>
        
        <Row>
          <Col span="12">
            <FormItem label="编码" prop="name">
              <Input v-model="form.code"></Input>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="条形码" prop="name">
              <Input v-model="form.barCode"></Input>
            </FormItem>
          </Col>
        </Row>

        <Row>
          <Col span="12">
            <FormItem label="建议零售价" prop="referencePrice">
              <InputNumber :min="0.01" :precision="2" :active-change="false" v-model="form.referencePrice"></InputNumber>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="实际价格" prop="salePrice">
              <InputNumber :min="0.01" :precision="2" :active-change="false" v-model="form.salePrice"></InputNumber>
            </FormItem>
          </Col>
        </Row>
        
        <Row>
          <Col span="12">
            <FormItem label="是否分期" prop="isStages">
              <sl-select v-model="form.isStages" type="radio" dict="$NY"></sl-select>
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="是否有保险" prop="isInsurance">
              <sl-select v-model="form.isInsurance" type="radio" dict="$NY"></sl-select>
            </FormItem>
          </Col>
        </Row>
        <FormItem label="分期方案" prop="skuFinance">
          <Select v-model="form.financeProducts" multiple style="width:100%;">
              <Option v-for="item in financeProducts" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>

        <FormItem label="SKU主图" prop="skuFileId">
          <sl-upload :public="true" :type="57" v-model="form.skuFilePath" :limit="1">如果未添加sku主图，则默认显示商品主图</sl-upload>
        </FormItem>

        <FormItem label="备注" prop="remark">
          <Input type="textarea" :autosize="{minRows: 2,maxRows: 5}" v-model="form.remark"></Input>
        </FormItem>
      </Form>
    </div>

    <div class="modal-footer">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div>
  </div>
  <!-- </Modal> -->
</template>
<script>
const setGroup = (data , flag = false) => {
  let m = {}
  data.forEach((i) => {
    let type = i.specType
    if (!m[type]) {
      m[type] = { name: i.specName, type:i.specType , value: -1, children: [] , visible : flag}
    }

    m[type].children.push({ ...i, value: i.id, label: i.specKey })
  })
  return Object.values(m)
}

const setSelect = (src , data) => src.forEach(i => data.find( j => {
  if(j.specType == i.type){
    i.value = j.id
    i.visible = true
  }
}))

const clean = (data) => {
  let specs = []
  data.forEach(i=>{
    let hit = i.children.find(j=>(j.id == i.value))
    if(hit){
      specs.push({ id : hit.id , specType:hit.specType, specName:hit.specName , specKey : hit.specKey , specVal : hit.specVal })
    }
  })
  
  // 无
  let emptySpec = specs.find( i => (i.specType == '1' && i.specVal == '0'))
  if( emptySpec ){
    specs = [ emptySpec ]
  }

  return specs
}

export default {
  props:{
    goodsId:{
      type:Number,
      default:undefined
    },
    skuId:{
      type:Number,
      default:undefined
    },
    goodsSpecs:{
      type:Array
    }
  },
  data() {
    return {
      rules: {
        name: [
          { required: true, message: '请输入SKU名称名称', trigger: 'blur,change' },
        ],
        code: [
          { required: true, message: '请输入SKU编码', trigger: 'blur,change' },
        ],
        barCode: [
          { required: true, message: '请输入条形码', trigger: 'blur,change' },
        ],
        referencePrice: [
          { required: true, type: 'number', message: '请输入建议零售价', trigger: 'blur,change' },
        ],
        salePrice: [
          { required: true, type: 'number', message: '请输入实际价格', trigger: 'blur,change' },
        ],
      },

      form: {
        id:null,
        name:null,
        code:null,
        barCode: null,
        referencePrice: null,
        salePrice: null,
        skuFilePath:null,
        isStages:null,
        isInsurance:null,
        width:null,
        height:null,
        length:null,
        remark: null
      },
      id:null,
      specs: [],
      loading: false,
      modalVisible:false,
      financeProducts:[],
      previewUrl: this.$request.goodsFileUrl(),
    }
  },

  created() {
    this.def = { ...this.form }
    this.init(this.goodsId, this.goodsSpecs, this.skuId)
  },
  computed:{
    title(){
      return this.id ? '修改SKU' : '新增SKU'
    },
    action(){
      return this.$request.goodsFileUploadUrl()
    }
  },

  mounted() {},

  methods: {
    init(goodsId ,specs, skuId) {
      this.reset()

      this.goodsId = goodsId
      this.specs = setGroup(specs , !skuId)
      console.log('>>', this.specs)
      if(skuId){
        this.id = skuId
        this.query()
      }else{
        this.id = null
      }

    },
    query(){
      this.$request.skuQuery(this.id).then(resp=>{
        this.$utils.fill(this.form , resp.data)
        setSelect( this.specs , resp.data.specs )
      })
    },
    reset() {
      this.$utils.fill(this.form, this.def)
      this.specs = []
      this.id = null
      this.$refs['form']?.resetFields()
    },
    save() {
      let goodsId = this.goodsId ,  specs = clean(this.specs)

      if(specs.length == 0){
        this.$Message.error('请选择规格')
        return
      }

      let params = { goodsId, specs, ...this.form }

      let promise = this.id ?  this.$request.skuUpdate : this.$request.skuCreate

      this.loading = true

      promise(params).then(resp => {

        if (resp.code) {
          this.$Message.error(resp.msg)
        } else {
          this.$Message.success('保存成功')
          this.modalVisible = false
          this.$emit('update')
        }
        this.loading = false
      })

    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },
    handleChangeSpec(v) {
      //选择 无
      if(v.specType == '1'){
        let visible = v.specVal != '0'
        this.specs.forEach(i=>{
          if(i.type != '1') i.visible = visible
        })
      }
    }
  }
}

</script>